import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { CountryConfig } from '../../types/apiConfig';

const initialState: CountryConfig[] = [];

const countryConfigSlice = createSlice({
  name: 'countryConfig',
  initialState,
  reducers: {
    loadCountryConfig: (state, action: PayloadAction<CountryConfig[]>) => {
      return action.payload;
    },
  },
});

export const countryConfigSelector = (state: RootState) => state.countryConfig;
export const { loadCountryConfig } = countryConfigSlice.actions;
export default countryConfigSlice.reducer;
